module.exports = __webpack_public_path__ + "static/media/education.7fc42230.webp";